import { render, staticRenderFns } from "./AdministrativeProcurementPricing.vue?vue&type=template&id=6a0b48c8&scoped=true"
import script from "./AdministrativeProcurementPricing.vue?vue&type=script&lang=js"
export * from "./AdministrativeProcurementPricing.vue?vue&type=script&lang=js"
import style0 from "./AdministrativeProcurementPricing.vue?vue&type=style&index=0&id=6a0b48c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b48c8",
  null
  
)

export default component.exports